const LIVE_GOOGLE_ANALYTICS_HOSTS = new Set([
  "thesitebook.co.uk",
  "www.thesitebook.co.uk",
  "do.thesitebook.co.uk",
]);

type AnalyticsLocation = Pick<Location, "hostname" | "protocol">;

function isLiveGoogleAnalyticsOrigin(protocol: string, hostname: string): boolean {
  return protocol === "https:" && LIVE_GOOGLE_ANALYTICS_HOSTS.has(hostname);
}

function getBrowserLocation(): AnalyticsLocation | null {
  if (typeof globalThis.location === "undefined") return null;
  return globalThis.location;
}

export function isGoogleAnalyticsEnabled(
  baseUrl = process.env.NEXT_PUBLIC_APP_BASE_URL,
  currentLocation: AnalyticsLocation | null = getBrowserLocation(),
): boolean {
  if (baseUrl) {
    try {
      const url = new URL(baseUrl);
      if (isLiveGoogleAnalyticsOrigin(url.protocol, url.hostname)) return true;
    } catch {
      // Fall through to the browser location check below.
    }
  }

  if (!currentLocation) return false;
  return isLiveGoogleAnalyticsOrigin(
    currentLocation.protocol,
    currentLocation.hostname,
  );
}

